import { ReactElement } from 'react';

type UISpacerProps = {
    multiplier?: number;
};
export function UISpacer(props: UISpacerProps): ReactElement {
    const { multiplier = 1 } = props;

    return (
        <div
            style={{
                width: 10 * multiplier,
                height: 10 * multiplier
            }}
        />
    );
}
